module.exports = __webpack_public_path__ + "img/IMG_7522.17800bb9.png";